/** @type {import('tailwindcss').Config} */
const tailwindConfig = {
  important: '#root',
  content: [
    './src/app/**/*.{js,ts,jsx,tsx}',
    './src/pages/**/*.{js,ts,jsx,tsx}',
    './src/components/**/*.{js,ts,jsx,tsx}',
    './src/modules/**/*.{js,ts,jsx,tsx}',
    './src/shared/**/*.{js,ts,jsx,tsx}',
  ],
  theme: {
    extend: {
      fontFamily: {
        sans: ['var(--font-poppins)', 'sans-serif'],
      },
      colors: {
        primary: {
          light: '#CBBAF8', // 30% più chiaro ex #6C7AFF30
          main: '#9766EC', // Colore principale ex #6C7AFF
          dark: '#7934CD', // 30% più scuro ex #5262FF
          contrastText: '#FCFCFC',
        },
        secondary: {
          light: '#EDA9FE', // 20% più chiaro ex #7248b8
          main: '#E67EFC', // Colore principale ex #B3EEFF
          dark: '#9F19B2', // 20% più scuro ex #8AE5FF
          contrastText: '#371765', // Contrasto del testo (opzionale) ex #15151A
        },
        complementary: {
          light: '#FDF18B', // ex #FF826B
          main: '#FBE34E', // ex #FF6043
          dark: '#C88D06', // ex #E95135
          contrastText: '#412107',
        },
        error: {
          light: '#FEE2E2',
          main: '#B91C1C',
          dark: '#9B1717',
        },
        success: {
          light: '#DDF7DC',
          main: '#15803D',
          dark: '#10602E',
        },
        text: {
          primary: '#E2E3E9',
          secondary: '#9597AC',
          disabled: '#515466 !important',
        },
        action: {
          divider: '#8C8D97',
          focus: '#393A47',
        },
        neutral: {
          main: '#54566870',
        },
        background: '#1C1D22', // Sostituisci con il colore di sfondo
        paper: '#15151A', // Colore superfici
        button: '#5B21B6', // Colore del bottone "Accedi"
        buttonDisabled: '#D1D5DB', // Colore del bottone disabilitato
      },
      borderRadius: {
        '4xl': '2.5rem', // Override the default 4xl radius to 40px
      },
    },
  },
  plugins: [],
};

export default tailwindConfig;
